import Choices from '../vendor/choices/choices';
import { addClass, removeClass } from '../tools/DOM';


export const init = () => {
	const elements = [...document.querySelectorAll('.js-select')];

	const OPTIONS = {
		searchEnabled: false,
		searchChoices: false,
		shouldSort: false,
	};


	const init = (element) => {
		const select = new Choices(element, OPTIONS);
		const placeholder = select.itemList.element.querySelector('.choices__placeholder');
		const id = select.passedElement.element.getAttribute('id');
		const label = document.querySelector(`[for='${id}']`);

		const highlightSelected = () => {
			const { choiceId } = select.getValue();
			const options = [...select.dropdown.element.querySelectorAll('.choices__item')];
			const selectedOption = select.dropdown.element.querySelector(`[data-id="${choiceId}"]`);

			options.forEach((option) => {
				removeClass(option, 'is-highlighted');
				option.setAttribute('aria-selected', false);
			});

			addClass(selectedOption, 'is-highlighted');
			selectedOption.setAttribute('aria-selected', true);
		};


		if (!placeholder) {
			addClass(label, 'is-active');
		}

		highlightSelected();
		select.passedElement.element.addEventListener('choice', (event) => {
			const isPlaceholder = event.detail.choice.placeholder;

			if (!isPlaceholder) {
				addClass(label, 'is-active');
			}
		});
		select.passedElement.element.addEventListener('hideDropdown', highlightSelected);
		select.passedElement.element.addEventListener('showDropdown', highlightSelected);

		return select;
	};


	elements.forEach(init);
};



// WEBPACK FOOTER //
// ./src/js/components/select.js